module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "id": "prompt"
    }
  }, [_vm._v("\n                julien@usson:" + _vm._s(_vm.path || _vm.statePath) + "$\n              ")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc98f63"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prompt.vue
// module id = 277
// module chunks = 1